import { render, staticRenderFns } from "./client-analyst-list.vue?vue&type=template&id=f2bf2b68&scoped=true"
import script from "./client-analyst-list.vue?vue&type=script&lang=js"
export * from "./client-analyst-list.vue?vue&type=script&lang=js"
import style0 from "./client-analyst-list.vue?vue&type=style&index=0&id=f2bf2b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bf2b68",
  null
  
)

export default component.exports